import './MultiChat.css';
import ChatWindow from '../@shared/ChatWindow';
import MultiChatContactsPanel from './multi_chat/MultiChatContactsPanel';
import { useContext, useState } from 'react';
import classNames from 'classnames';
import SubscriptionChatsContext from '../../contexts/data/SubscriptionChatsContext';
import { Spin } from 'antd';
import { CommentOutlined } from '@ant-design/icons';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface MultiChatProps { }

const MultiChat: React.FC<MultiChatProps> = (props) => {
  const subscriptionChatsContext = useContext(SubscriptionChatsContext);
  const [isPanelOpen, setIsPanelOpen] = useState(true);

  return (
    <div className="multi-chat">
      <div
        className={classNames({
          'multi-chat__contacts-panel-container': true,
          'multi-chat__contacts-panel-container--closed': !isPanelOpen,
        })}
      >
        <MultiChatContactsPanel onContactSelect={() => setIsPanelOpen(false)} />
      </div>
      <div
        className={classNames({
          'multi-chat__chat-window-container': true,
          'multi-chat__chat-window-container--closed': isPanelOpen,
        })}
      >
        {subscriptionChatsContext.contactsCount === 0 &&
          subscriptionChatsContext.selectedContact === null ? (
          <div className="multi-chat__chat-window-container__placeholder">
            <CommentOutlined style={{
              fontSize: '2em',
              marginBottom: '0.5rem'
            }} />
            <p>Aucune conversation disponible</p>
          </div>
        ) : subscriptionChatsContext.selectedContact === null ?
          (
            <div className="multi-chat__chat-window-container__loading-container">
              <Spin />
            </div>
          ) :
          (
            <ChatWindow
              contactId={subscriptionChatsContext.selectedContact?.id || ''}
              multiMode
              onOneMessageRead={(becomeRead, role) =>
                subscriptionChatsContext.onOneMessageReadStatusChange(
                  becomeRead,
                  role
                )
              }
              onReadAll={() => subscriptionChatsContext.onAllMessagesReading()}
              onMobileNavBack={() => setIsPanelOpen(true)}
            />
          )}
      </div>
    </div>
  );
};

export default MultiChat;
